import React from "react";

/**
 * Friendly empty state used inside Card/Table containers when there's
 * nothing to show. Replaces the plain "No data" text rows that the
 * legacy pages had.
 *
 * Style: matches the theme's typography (text-muted, fw-medium) and
 * uses a soft colored icon disc.
 */
const TONE_HEX = {
  primary: "#405189",
  success: "#0ab39c",
  info: "#299cdb",
  warning: "#f7b84b",
  danger: "#f06548",
  secondary: "#74788d",
};

const EmptyState = ({
  icon = "ri-inbox-line",
  title = "Nothing here yet",
  message,
  tone = "secondary",
  action,
  compact = false,
}) => {
  const hex = TONE_HEX[tone] || TONE_HEX.secondary;
  const padY = compact ? 24 : 40;
  const discSize = compact ? 48 : 72;

  return (
    <div
      className="text-center"
      style={{
        padding: `${padY}px 16px`,
      }}
    >
      <div
        className="d-inline-flex align-items-center justify-content-center mb-3"
        style={{
          width: discSize,
          height: discSize,
          borderRadius: "50%",
          background: `${hex}14`,
          color: hex,
        }}
      >
        <i
          className={icon}
          style={{ fontSize: compact ? 22 : 32 }}
        />
      </div>
      <h6 className="fw-semibold mb-1" style={{ color: "var(--ssw-text-1, #212529)" }}>
        {title}
      </h6>
      {message ? (
        <p
          className="text-muted mb-3"
          style={{ fontSize: 13, maxWidth: 360, margin: "0 auto" }}
        >
          {message}
        </p>
      ) : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
};

export default React.memo(EmptyState);
